var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { TEXT_VARIANTS, } from '../../utils/textVariants';
import { textColorStyles, textVariantStyles } from './Text.css';
export const Text = React.forwardRef(function Text(_a, ref) {
    var { as, asHtml, children, className, color, variant = TEXT_VARIANTS._14 } = _a, rest = __rest(_a, ["as", "asHtml", "children", "className", "color", "variant"]);
    const dangerouslySetInnerHTML = asHtml && typeof children === 'string' ? { __html: children } : undefined;
    const Component = as || (dangerouslySetInnerHTML ? 'div' : 'span');
    return (_jsx(Component, Object.assign({}, rest, { className: cx(textVariantStyles[variant], color && textColorStyles[color], className), dangerouslySetInnerHTML: dangerouslySetInnerHTML, ref: ref, children: dangerouslySetInnerHTML ? null : children })));
});
